import React, { useContext } from 'react'

import { P } from '../../../styles/Typograph.styles'
import InputWrapper from '../../../components/MiniComponents/InputWrapper'
import Input from '../../../components/controls/Input'
import SubFileUpload from '../../../components/MiniComponents/SubFileUpload'
import SpacingLine from '../../../components/SpacingLine'
import IconContainer from '../../../components/controls/Icons'

import { FiExternalLink } from 'react-icons/fi'

import { WorkEthicsContext } from '../../../context/WorkEthics'

const OoklaTest = () => {
  const {
    ooklaLink,
    setOoklaLink,
    ooklaScreenshot,
    setOoklaScreenshot,
    downloadSpeed,
    setDownloadSpeed,
    uploadSpeed,
    setUploadSpeed,
    ping,
    setPing,
  } = useContext(WorkEthicsContext)

  return (
    <>
      <SpacingLine full />
      <P>
        We recommend using Speedtest by Ookla to test your internet speed.
        <a target="_blank" href="https://www.speedtest.net/" rel="noreferrer">
          <IconContainer color="#1877F2" ml=".5rem">
            <FiExternalLink className="icon" />
          </IconContainer>
        </a>
      </P>

      <InputWrapper mt="1.5rem" label="Speedtest Result Link" required>
        <Input
          required
          type="text"
          value={ooklaLink}
          placeholder="Ookla Result Link"
          onChange={(e) => {
            setOoklaLink(e.target.value)
          }}
        />
      </InputWrapper>

      <InputWrapper mt="1.5rem" label="Download Speed">
        <Input
          type="number"
          value={downloadSpeed}
          placeholder="Download Speed (Mbps)"
          onChange={(e) => {
            setDownloadSpeed(e.target.value)
          }}
        />
      </InputWrapper>

      <InputWrapper mt="1.5rem" label="Upload Speed">
        <Input
          type="number"
          value={uploadSpeed}
          placeholder="Upload Speed (Mbps)"
          onChange={(e) => {
            setUploadSpeed(e.target.value)
          }}
        />
      </InputWrapper>

      <InputWrapper mt="1.5rem" label="Ping">
        <Input
          type="number"
          value={ping}
          placeholder="Ping (ms)"
          onChange={(e) => {
            setPing(e.target.value)
          }}
        />
      </InputWrapper>

      <SubFileUpload
        label="Speedtest Screenshot"
        noBorder
        maxW="100%"
        pt=".5rem"
        attachment={ooklaScreenshot}
        setAttachment={setOoklaScreenshot}
      />
    </>
  )
}

export default OoklaTest
